import { createAction, props } from '@ngrx/store';
import { ILocation, LocationForBerthPlanner } from '../model/location';
import { IQueryResult } from '@pmis3/data-access';

export enum LocationActionTypes {
    Load = '[Locations Page] Load Locations',
    LoadAllLocations = '[Locations Page] Load All Locations',
    LoadLocationsForBerthPlanner = '[Locations Page] Load Locations For Berth Planner',
    LoadSuccess = '[Locations Page] Load Locations Success',
    LoadFail = '[Locations Page] Load Locations Fail',
    LoadLocationsForNOA = '[Locations Page] Load Locations For NOA',
    LoadTerminalsForNOA = '[Locations Page] Load Terminals For NOA',
}

export const Load = createAction(LocationActionTypes.Load);

export const LoadAllLocations = createAction(
    LocationActionTypes.LoadAllLocations
);

export const LoadLocationsForBerthPlanner = createAction(
    LocationActionTypes.LoadLocationsForBerthPlanner
);

export const LoadLocationsForBerthPlannerSuccess = createAction(
    LocationActionTypes.LoadSuccess,

    props<{ result: LocationForBerthPlanner[] }>()
);

export const LoadSuccess = createAction(
    LocationActionTypes.LoadSuccess,

    props<{ result: IQueryResult<ILocation> }>()
);

export const LoadFail = createAction(
    LocationActionTypes.LoadFail,

    props<{ error: string }>()
);

export const LoadLocationsForNOA = createAction(
    LocationActionTypes.LoadLocationsForNOA,
    props<{ locations: ILocation[], terminals: ILocation[] }>()
);
